import React from "react";
import QuestionOverview from "./components/QuestionOverview/QuestionOverview";
import { connect } from "react-redux";
import { questionActions } from "../../../store/actions/question/question.action";
import { clientTypeConstants } from "../../constants/clientType.constants";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { deepClone } from "../../../helpers/objectHelper";
import { templateActions } from "../../../store/actions/cms/template/template.action";
import HeaderBar from "./components/HeaderBar";
import ActiveItems from "./components/ActiveItems/ActiveItems";
import SettingsAside from "./components/Settings/SettingsAside/SettingsAside";
import Axios from "axios";
import ClientOverview from "./components/ClientOverview/ClientOverview";
import { ActiveInfo } from "./components/ActiveInfo";
import { handleResponse } from "../../../helpers/handleresponse";
import SpeakerOverview from "./components/SpeakerOverview/SpeakerOverview";
import CustomSnackbar from "./components/UI/Notifier";

import PresetOverview from "./components/ActiveItems/Preset/PresetOverview";
import AgendaEditView from "./components/ActiveItems/Agenda/AgendaEditView";
import ChatWindow from "./components/Chat/ChatWindow/ChatWindow";
import "./ModeratorLayout.css";
import { ModulesConflictModal } from "./components/ModuleConflictModal";
import { ClientConnectionFallback, Loader } from "../../../digitalArena/utils/ClientConnectionFallback";
import { ConnectionStatus } from "../../../digitalArena/components/fallbacks/ConnectionStatus";
import { sourceTypes } from "../../../constants/cms/sourceType";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import AgendaList from "./components/ActiveItems/Agenda/AgendaList";
import { Card, CardContent } from "@material-ui/core";

class NewLayout extends React.Component {
  state = {
    hubConnection: null,
    connected: false,
    presenters: [1, 2, 3],
    clients: 0,
    showClients: true,
    agenda: [],
    speakers: [],
    eventId: -1,
    arenaClosed: false,
    showSpeaker: null,
    asideOpen: false,
    connectionList: [],
    orderList: [],
    allowSpeaker: false,
    activeQuestions: [],
    activePresenterQuestion: 0,
    clientResponses: [],
    questionPresentParticipants: [],
    showAgendaInfo: null,
    selectedAgenda: null,
    clientTemplateId: 0,
    defaultLanguage: "swe",
    timer: 1,
    buttonTimers: [],
    activeAgenda: null,
    presenterSettings: {
      displayTypeText: "TEXTFLOW",
      displayTypeOption: "BARCHART",
      moderationMode: false,
      presentationOrder: "SORTORDER",
      showCount: true,
      showPercent: false,
    },
    // moderationMode: false,
    // presentationOrder: "SORTORDER",
    forceQuestion: false,
    selectedQuestion: null,
    tcpConnections: null,
    activePreset: null,
    allowChat: true,
    snackbar: {
      show: false,
      message: "",
      status: null,
    },
    scroll: false,
    breakouts: [],
    tickCode: null,
    eventCode: null,
    connecting: false,
    personTypes: [],
    init: false,
    activeMobileLayout: null,
    modules: [],
    currentChat: null,
    chats: [],
    eventName: "",
    questionTagList: [],
    activeModulesChanged: false,
    parentEvent: null,
    selectedPreset: null,
    conflictedModules: [],
    questionAgendaSplitView: false,
    eventLang: null,
    code: "",
    presetItems: [],

    conflictedModuleWarning: false,
  };
  deactivateAgendaSpeakersOnClose = (agendaItemId) => {
    this.hubConnection.invoke("deactivateSpeakersOnAgendaClosed", this.state.eventId, agendaItemId).catch((err) => {
      this.onError(err);
    });
  };

  onModuleImport = ({ allModules, newPresets }) => {
    const cf = newPresets.map((p) => {
      p.content = JSON.parse(p.content);
      return p;
    });
    this.setState({
      modules: this.state.modules.concat(allModules),
      presetItems: cf,
    });
  };
  tryReconnect = () => {
    if (!this.state.connected && !this.state.connecting) {
      this.connectToHub();
    }
  };
  getModules = (eventId) => {
    Axios.get(`./api/meeting/${eventId}`)
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({
            modules: res.data,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  componentDidMount() {
    const { dispatch } = this.props;
    let eventId = this.props.match.params.id;
    document.body.style.background = "black";

    if (isNaN(eventId)) {
      this.setState({ connecting: true, eventCode: eventId });
      this.getEventId(eventId);
    } else {
      this.setState({ connecting: true, eventId: eventId });
      this.getEventCode(eventId);
      dispatch(questionActions.getAllQuestionsByEvent(eventId, false));
      dispatch(templateActions.getAll(eventId, true));
    }

    this.getAgenda(eventId);
    this.getSpeakers(eventId);
    this.getModules(eventId);
    this.activeInfoRef = React.createRef();
    this.clientViewRef = React.createRef();
    this.randomButtonFullCheckTimer = React.createRef();

    this.randomButtonFullCheckTimer = {};
  }
  componentDidUpdate(prevProps, prevState) {
    const { connecting, connected } = this.state;

    if (connected == false && prevState.connected == true && connecting == false) {
      this.tryReconnect();
      this.counter = setInterval(() => this.setState({ countdown: this.state.countdown + 1 }), 1000);
    } else if (this.state.countdown >= 60 && !connected && prevState.connected == false) {
      this.setState({ countdown: 0, connecting: false });
      this.tryReconnect();
    } else if (connected == true && prevState.connected == false && !this.state.connecting && this.hubConnection && this.hubConnection.connectionState == 1) {
      if (this.counter) clearInterval(this.counter);
      this.setState({ countdown: 0 });
    }
  }
  connectToHub = () => {
    if (!this.hubConnection) {
      try {
        this.hubConnection = new HubConnectionBuilder().withUrl("./ihub").build();
      } catch (error) {}
    }
    let clientKey = this.getClientKey();
    const { eventId } = this.state;
    const { user } = this.props;

    this.hubConnection
      .start()
      .then(() => {
        this.hubConnection.on("onHandshake", this.onHandshake);
        this.hubConnection.on("onModuleImport", this.onModuleImport);
        this.hubConnection.on("onArenaClosed", this.onArenaClosed);
        this.hubConnection.on("onGetChatMessage", this.onGetChatMessages);
        this.hubConnection.on("onSendChatMessage", this.onSendChatMessage);
        this.hubConnection.on("onChatMessageReceived", this.onReceiveMessage);
        this.hubConnection.on("onLikeMessage", this.onLike);
        this.hubConnection.on("onRandomButtonFullCheck", this.onRandomButtonFullCheck);
        this.hubConnection.on("onActiveModulesChanged", this.onActiveModulesChanged);
        this.hubConnection.on("onGetActiveConnections", this.onGetActiveConnections);
        this.hubConnection.on("onGetActiveQuestions", this.onGetActiveQuestions);
        this.hubConnection.on("onClearEventData", () => this.setState({ clientResponses: [], speakers: [] }));
        this.hubConnection.on("onAgendaClosed", (res) => this.setState({ speakers: res }));
        this.hubConnection.on("onSpeakersUpdate", this.onSpeakersUpdate);
        this.hubConnection.on("onUpdatedClientSettings", this.onUpdatedClientSettings);
        this.hubConnection.on("onAgendaUpdate", this.onAgendaUpdate);
        this.hubConnection.on("onUpdatedPresenterSettings", this.onUpdatedPresenterSettings);
        this.hubConnection.on("onClientResponse", this.onClientResponse);
        this.hubConnection.on("onToggleQuestionInfo", this.onToggleQuestionInfo);
        this.hubConnection.on("onNewPresentParticipant", this.onNewPresentParticipant);
        this.hubConnection.on("onToggleQuestion", this.onToggleQuestion);
        this.hubConnection.on("onLoadMeetingLayoutPresets", this.onLoadMeetingLayoutPresets);

        this.hubConnection.on("onDeployQuestionToPresenter", this.onDeployQuestionToPresenter);
        this.hubConnection.on("onClearQuestionAnswers", this.onClearQuestionAnswers);
        this.hubConnection.on("onGetActiveMeetingLayout", (layout) => {
          const groupGeneratorModules = layout && layout.meetingModules.filter((l) => l.meetingModule && l.meetingModule.moduleType == "GroupGenerator");
          if (groupGeneratorModules && groupGeneratorModules.length > 0) {
            groupGeneratorModules.map((g) => {
              const settings = JSON.parse(g.meetingModule.settings);
              const { breakoutId, rooms, max } = settings;
              if (!breakoutId) return;
              this.randomButtonFullCheck(breakoutId, rooms, max);
            });
          }
        });
        this.hubConnection.on("onGetActiveMobileMeetingLayout", (layout) => {
          const groupGeneratorModules = layout && layout.meetingModules.filter((l) => l.meetingModule && l.meetingModule.moduleType == "GroupGenerator");
          if (groupGeneratorModules && groupGeneratorModules.length > 0) {
            groupGeneratorModules.map((g) => {
              const settings = JSON.parse(g.meetingModule.settings);
              const { breakoutId, rooms, max } = settings;
              if (!breakoutId) return;
              this.randomButtonFullCheck(breakoutId, rooms, max);
            });
          }
          if (layout && layout.mobile) {
            this.setState({ activeMobileLayout: layout });
          }
        });
        this.hubConnection.on("onGetOrderList", this.onGetOrderList);
        this.hubConnection.on("onActivateQuestion", this.onActivateQuestion);
        /*         this.hubConnection.on("onGetTcpConnections", this.onGetTcpConnections); */
        this.hubConnection.onclose(() => {
          this.setState({ connected: false });
        });

        this.hubConnection
          .invoke("handshake", {
            eventId: parseInt(eventId),
            clientType: clientTypeConstants.INTERACTION_MODERATOR,
            clientKey,
            userGuid: user.userGuid,
          })
          .catch((err) => {
            console.error(err);
          });
        this.hubConnection.invoke("getChatMessages", eventId, "MODERATOR", null, false);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  restoreAgendaItem = (agendaItemId) => this.hubConnection.invoke("restoreAgendaItem", agendaItemId);
  onLoadMeetingLayoutPresets = (presets, presetId, ug = null) => {
    const userGuid = this.props.user.userGuid;
    if (presetId == -1000 && this.state.presetItems.length > 0) {
      const presetItems = this.state.presetItems.map((pi) => {
        const pre = presets.find((p) => p.interactionPresetId == pi.interactionPresetId);
        if (pre) {
          const newPre = { ...pre };
          newPre.name = pre.name;
          newPre.sortOrder = pre.sortOrder;
          newPre.updated = pre.updated;
          return newPre;
        }
        return pre;
      });
      this.setState({ presetItems });
    } else if (presetId > 0 && this.state.selectedPreset && this.state.selectedPreset == presetId && userGuid != ug) {
      this.setState({
        conflictedModules: presets.find((p) => p.interactionPresetId == presetId),
        conflictedModuleWarning: true,
      });
    } else {
      const cf = presets.map((p) => {
        p.content = JSON.parse(p.content);
        return p;
      });
      this.setState({ presetItems: cf });
    }
  };
  onActiveModulesChanged = (ug = null) => {
    const userGuid = this.props.user.userGuid;
    if (userGuid != ug) {
      this.setState({ activeModulesChanged: true });
    }
  };

  resolveModuleConflict = (accept = false, presetId = 0) => {
    const presetItem = this.state.presetItems.find((p) => p.interactionPresetId == this.state.conflictedModules.interactionPresetId);
    if (presetItem) {
      presetItem.content = JSON.parse(this.state.conflictedModules.content);
      const presetItems = Array.from(this.state.presetItems);
      presetItems.map((p) => {
        if (p.interactionPresetId == presetItem.interactionPrestId) {
          p = presetItem;
        }
      });
      if (accept) {
        this.setState(
          {
            presetItems,
            selectedPreset: presetItem,
            conflictedModuleWarning: false,
          },
          () => this.updateModulesList(presetItem.content)
        );
      } else {
        this.setState({
          presetItems,
          selectedPreset: null,
          conflictedModuleWarning: false,
        });
      }
    }
  };
  getBreakouts = () => {
    const { eventId } = this.state;
    Axios.get(`./api/meeting/breakouts/${eventId}`).then((res) => {
      if (res.data && res.data.length > 0) {
        this.setState({
          breakouts: res.data.filter((r) => r.eventId != eventId),
        });
      }
    });
  };

  onRandomButtonFullCheck = ({ code, breakoutId, roomCount, roomMax }) => {
    if (code == "OPEN") {
      if (this.randomButtonFullCheckTimer && this.randomButtonFullCheckTimer[breakoutId]) clearInterval(this.randomButtonFullCheckTimer[breakoutId]);
      /*    this.randomButtonFullCheckTimer[breakoutId] = null; */
      /*  this.randomButtonFullCheck(breakoutId, roomCount, roomMax); */
    } else {
      if (!this.randomButtonFullCheckTimer || !this.randomButtonFullCheckTimer[breakoutId]) {
        this.randomButtonFullCheckTimer[breakoutId] = setInterval(() => this.randomButtonFullCheck(breakoutId, roomCount, roomMax), 10000);
      }
    }
  };
  randomButtonFullCheck = (breakoutId, rooms, max) => {
    if (!breakoutId || !this.state.connected || this.hubConnection.connectionState != 1) return;
    this.hubConnection.invoke("getBreakoutChannel", this.state.eventId, parseInt(breakoutId), parseInt(rooms), parseInt(max), "", true);
  };
  onArenaClosed = (status) => {
    this.setState({ arenaClosed: status });
  };
  setArenaClosed = () => {
    if (this.state.arenaClosed == false) {
      if (window.confirm("Closing the arena will disconnect all active participants. Are you sure? ")) {
        this.setState({ arenaClosed: !this.state.arenaClosed });
        this.hubConnection.invoke("ToggleArenaClosed", this.state.eventId);
      }
    } else {
      this.setState({ arenaClosed: !this.state.arenaClosed });
      this.hubConnection.invoke("ToggleArenaClosed", this.state.eventId);
    }
  };
  onHandshake = (response) => {
    if (response.success) {
      this.setClientKey(response.clientKey);
      let questionTagList = response.interactionFilterQuestionsByTags ? response.interactionFilterQuestionsByTags.split(":") : [];
      this.setState({
        connected: true,
        code: response.code,
        tickCode: response.tickCode,
        questionTagList,
        eventLang: response.lang,
        defaultLanguage: response.lang,
        allowSpeaker: response.allowSpeaker,
        allowChat: response.interactionAllowModeratorChat,
        connecting: false,
        init: true,
        parentEvent: response.parentEvent,
      });
      if (response.parentEvent) {
        this.props.dispatch(templateActions.getAll(response.parentEvent.eventId, true));
        this.props.dispatch(questionActions.getAllQuestionsByEvent(this.state.eventId, false));
        this.getPersonTypes(response.parentEvent.eventId);
        this.hubConnection.invoke("getOrderList", response.parentEvent.eventId).catch((err) => {
          this.onError(err);
        });
      } else {
        this.hubConnection.invoke("getOrderList", this.state.eventId).catch((err) => {
          this.onError(err);
        });
        this.getPersonTypes(this.state.eventId);
      }
      this.getBreakouts();
      /*      this.randomButtonFullCheck(); */
      this.hubConnection.invoke("getActiveConnections", this.state.eventId, null, null).catch((err) => {
        this.onError(err);
      });
      this.hubConnection.invoke("getArenaClosedStatus", this.state.eventId).catch((err) => {
        this.onError(err);
      });
      /*   this.hubConnection.invoke("getClientSettings", this.state.eventId).catch((err) => {
        this.onError(err);
      }); */

      this.hubConnection.invoke("getActiveMeetingLayout", this.state.eventId);
      this.hubConnection.invoke("getActiveMobileMeetingLayout", this.state.eventId);
      if (!this.connectionTimer) {
        this.connectionTimer = setInterval(() => {
          this.hubConnection.invoke("getActiveConnections", this.state.eventId, null, null).catch((err) => {
            this.onError(err);
          });
        }, 5000);
      }
      if (!this.orderListTimer) {
        if (response.parentEvent) {
          this.orderListTimer = setInterval(() => {
            this.hubConnection.invoke("getOrderList", response.parentEvent.eventId).catch((err) => {
              this.onError(err);
            });
          }, 60000);
        } else {
          this.orderListTimer = setInterval(() => {
            this.hubConnection.invoke("getOrderList", this.state.eventId).catch((err) => {
              this.onError(err);
            });
          }, 60000);
        }
      }
    } else {
      console.error(response.message);
    }
  };
  getEventId = (eventCode) => {
    const { dispatch } = this.props;
    Axios.get(`./api/event/getId/${eventCode}`)
      .then((res) => {
        const { id, parentEventId, name } = res.data;
        dispatch(questionActions.getAllQuestionsByEvent(res.data.id));
        dispatch(templateActions.getAll(res.data.id, true));

        dispatch(cmsActions.setEnviroment(sourceTypes.MEETING, true, parentEventId || id));
        this.setState({ eventId: res.data.id, eventName: res.data.name, eventLang: res.data.languageCode }, () => this.connectToHub());
        document.title = "Moderator - " + res.data.name;
      })
      .catch((err) => {
        console.error(err);
      });
  };
  getEventCode = (eventId) => {
    const { dispatch } = this.props;
    Axios.get(`./api/event/getCode/${eventId}`)
      .then((res) => {
        const { id, parentEventId, name } = res.data;
        dispatch(cmsActions.setEnviroment(sourceTypes.MEETING, true, parentEventId || eventId));
        this.setState({ eventCode: res.data.code, eventName: res.data.name }, () => this.connectToHub());
        document.title = "Moderator - " + res.data.name;
      })
      .catch((err) => {
        console.error(err);
      });
  };
  getPersonTypes = (eventId) => {
    Axios.get(`./api/event/persontypes/${eventId}`)
      .then((res) => {
        this.setState({ personTypes: res.data });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  getSpeakers = (eventId) => {
    Axios.get(`./api/meeting/speakers/${eventId}`)
      .then((res) => {
        this.setState({ speakers: res.data || [] });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  onGetOrderList = (list) => {
    this.setState({ orderList: list });
  };
  setClientKey = (key) => {
    localStorage.setItem("CLIENT_KEY_" + this.state.eventId, key);
  };
  getClientKey = () => {
    return localStorage.getItem("CLIENT_KEY_" + this.state.eventId) || null;
  };

  deleteModule = (id) => {
    if (!id) return;
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    return fetch(`./api/meeting/deletemodule/${id}`, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        const modules = Array.from(this.state.modules.filter((m) => m.digitalMeetingItemId !== data.deletedId));
        this.setState({ modules });
        this.hubConnection.invoke("updateMeetingLayout", modules, this.state.eventId).catch((err) => {
          this.onError(err);
        });
      });
  };
  updateModulesList = (modules, autoSave, presetId) => {
    this.setState({ modules }, () => {
      if (autoSave) {
        this.updateMeetingLayout(presetId);
      }
    });
  };
  updateMeetingLayout = (presetId) => {
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.state.modules),
    };

    return fetch(`./api/meeting/`, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          modules: data,
        });
        this.hubConnection.invoke("updateMeetingLayout", this.state.modules, this.state.eventId, presetId || 0, this.props.user.userGuid).catch((err) => {
          this.onError(err);
        });
      });
  };

  activatePresetItem = (id) => {
    const { presetItems } = this.state;
    const presetItem = presetItems.find((p) => p.interactionPresetId === id);
    if (!presetItem || presetItem.active === true) return;
    if (presetItem.content && Array.isArray(presetItem.content)) {
      this.updateModulesList(presetItem.content, true, presetItem.interactionPresetId);
    }
  };
  saveMeetingLayoutPreset = (name) => {
    const { user } = this.props;
    this.hubConnection.invoke("saveMeetingLayoutPreset", this.state.eventId, name, JSON.stringify(this.state.modules), user.userGuid).catch((err) => {
      this.onError(err);
    });
  };
  updateMeetingLayoutPresets = (items) => {
    const newItems = Array.from(
      items.map((n) => {
        let item = deepClone(n);
        item.content = ""; //empty the content to reduce the amount of data sent to server, since this call is only for changing name and/or sortOrder
        return item;
      })
    );
    const { user } = this.props;
    this.hubConnection.invoke("updateMeetingLayoutPresets", this.state.eventId, newItems, user.userGuid).catch((err) => {
      this.onError(err);
    });
  };
  deleteMeetingLayoutPreset = (id) => {
    const { user } = this.props;
    this.hubConnection.invoke("deleteMeetingLayoutPreset", id, user.userGuid).catch((err) => {
      this.onError(err);
    });
  };
  selectPreset = (id) => {
    if (this.state.selectedPreset == id) {
      this.setState({ selectedPreset: null });
    } else {
      this.setState({
        selectedPreset: id,
        selectedQuestion: null,
        showAgendaInfo: null,
        currentChat: null,
      });
    }
  };

  updatateModules = (modules) => {
    const { user } = this.props;
    this.hubConnection.invoke("updateMeetingLayout", modules, this.state.eventId, this.state.selectedPreset, user.userGuid).catch((err) => {
      this.onError(err);
    });
  };
  createModule = (createComponent) => {
    if (!createComponent) return;

    const { eventId } = this.state;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };

    return fetch(`./api/meeting/createmodule/${eventId}?moduleName=${createComponent}`, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        const modules = Array.from(this.state.modules);
        modules.push(data);
        this.setState({ modules });
      });
  };
  showSpeaker = (id) => this.setState({ showSpeaker: id, showClients: true });

  onClearQuestionAnswers = (res) => {
    if (res) {
      let uptResponses = Array.from(this.state.clientResponses);
      uptResponses = uptResponses.filter((r) => r.questionId !== res);
      this.setState({ clientResponses: uptResponses });
      this.snackbarHandler("AnswersHasBeenDeletedOnQuestion", "success");
    }
  };
  onAgendaUpdate = (res) => this.setState({ agenda: res });
  onSpeakersUpdate = (res) => this.setState({ speakers: res });

  onGetTcpConnections = (response) => {
    this.setState({ tcpConnections: response });
  };

  onUpdatedClientSettings = (settings) => {
    this.setState({
      clientTemplateId: settings.activeTemplateId,
    });
  };
  onUpdatedPresenterSettings = (settings) => {
    this.setState({ presenterSettings: settings });
  };
  onNewConnection = (conn) => {
    const { connectionList } = this.state;
    let newList = Array.from(connectionList);
    newList.push(conn);
    this.setState({ connectionList: newList });
  };
  onNewDisconnection = (connectionId) => {
    const { connectionList } = this.state;
    let newList = Array.from(connectionList);
    let dConn = newList.find((el) => el.connectionId == connectionId);
    if (dConn) {
      newList.splice(newList.indexOf(dConn), 1);
      this.setState({ connectionList: newList });
    }
  };

  onGetActiveConnections = (list) => {
    this.setState({ connectionList: list });
  };

  convertOptionIdToText = (id, questionId) => {
    let optionId = parseInt(id);
    if (isNaN(optionId)) return "";
    const { defaultLanguage } = this.state;
    const { questions } = this.props;
    const question = questions.find((q) => {
      return q.questionId === questionId;
    });
    let text = id;
    if (question) {
      try {
        text = question.questionOption.find((o) => o.questionOptionId === optionId).questionOptionLanguage.find((l) => l.languageCode === defaultLanguage).label;
      } catch (error) {}
    }
    return text;
  };

  onClientResponse = (response) => {
    const responses = Array.from(this.state.clientResponses);
    const existingResponse = responses.find((r) => {
      return r.answerId === response.answerId;
    });
    if (existingResponse) {
      let indexOf = responses.indexOf(responses.find((r) => r.answerId === response.answerId));
      if (indexOf > -1) {
        responses[indexOf].status = response.status;
      }
    } else if (response.type === "Option") {
      response.answerText = this.convertOptionIdToText(response.answer, response.questionId);
    }
    if (!existingResponse) {
      responses.push(response);
    }
    this.setState({ clientResponses: responses });
  };
  onError = (error) => this.setState({ error });

  onGetActiveQuestions = (qList) => {
    if (qList.length > 0) {
      let questionIds = qList.map((ql) => {
        return ql.question.questionId;
      });
      this.setState({ activeQuestions: questionIds });
    }
  };
  onToggleQuestion = (response) => {
    let newList = Array.from(this.state.activeQuestions);
    if (response.active) {
      newList.push(response.questionId);
    } else {
      newList = newList.filter((q) => q !== response.questionId);
    }
    this.setState({ activeQuestions: newList });
  };
  refreshQuestionList = () => {
    this.props.dispatch(questionActions.getAllQuestionsByEvent(this.state.eventId));
  };
  onDeployQuestionToPresenter = (response) => {
    if (response.active) {
      this.setState({ activePresenterQuestion: response.questionId });
    } else {
      this.setState({ activePresenterQuestion: 0 });
    }
  };
  deployQuestionToClients = (questionId) => {
    const { buttonTimers, quizSettings, activeQuestions } = this.state;
    let newButtonTimers = Array.from(buttonTimers);
    var timer = newButtonTimers.find((el) => el.questionId == questionId);
    if (timer) {
      newButtonTimers = buttonTimers.filter((bt) => bt.questionId != questionId);
    }

    this.setState({ buttonTimers: newButtonTimers });
    this.hubConnection.invoke("toggleQuestion", questionId, parseInt(this.state.eventId), this.state.forceQuestion, "INTERACTION_CLIENT").catch((err) => {
      this.onError(err);
    });
  };
  setAllowedAnswersCount = (questionId, value) => {
    let question = this.props.questions.find((q) => q.questionId == questionId);
    if (value < 1) {
      value = null;
    }
    if (question) {
      let newQuestion = deepClone(question);
      newQuestion.allowedAnswerCount = value;
      this.props.dispatch(questionActions.updateQuestion(newQuestion));
    }
  };
  onNewPresentParticipant = (order) => {
    const { questionPresentParticipants, selectedQuestion, activePresenterQuestion } = this.state;
    if (selectedQuestion && selectedQuestion.questionId == activePresenterQuestion) {
      if (!questionPresentParticipants.find((x) => x.badgeNo == order.badgeNo)) {
        questionPresentParticipants.push(order);
        this.setState({ questionPresentParticipants });
      }
    }
  };
  toggleQuestionInfo = (question) => {
    this.setState({ showClients: false });
    if (!question) {
      this.setState({
        selectedQuestion: null,
        clientResponses: [],
      });
    } else {
      this.setState({
        selectedQuestion: question,
        selectedPreset: null,
        selectedAgenda: null,
        showAgendaInfo: null,
        currentChat: null,
      });
      this.hubConnection.invoke("toggleQuestionInfo", question.questionId, question.eventId, question.type, true);
    }
  };
  onToggleQuestionInfo = (response) => {
    this.setState({ clientResponses: response.clientResponses, questionPresentParticipants: response.presentParticipants || [] });
  };
  deployQuestionToPresenter = (questionId) => {
    this.hubConnection.invoke("toggleQuestion", questionId, parseInt(this.state.eventId), this.state.forceQuestion, "INTERACTION_PRESENTER").catch((err) => {
      this.onError(err);
    });
  };
  clearResponsesOnPresenter = () => {
    const clientResponses = Array.from(
      this.state.clientResponses.map((cr) => {
        if (cr.status === 2) {
          cr.status = 3;
        }
        return cr;
      })
    );
    this.setState({ clientResponses });
    this.hubConnection.invoke("ClearResponses", this.state.eventId);
  };
  showSpeakers = (agendItemId) => {
    if (this.state.showAgendaInfo === agendItemId) {
      this.setState({ showAgendaInfo: null });
    } else {
      this.setState({
        showAgendaInfo: agendItemId,
        showClients: true,
        selectedQuestion: null,
        selectedAgenda: null,
        selectedPreset: null,
        currentChat: null,
      });
    }
  };
  updatePresenterSettings = (updatedSettings) => {
    const { eventId } = this.state;
    this.setState({ presenterSettings: updatedSettings });
    this.hubConnection.invoke("updatePresenterSettings", eventId, updatedSettings).catch((err) => {
      this.onError(err);
    });
  };
  setForceQuestion = (e) => this.setState({ forceQuestion: e.target.checked });

  updateClientSettings = (template) => {
    this.hubConnection.invoke("updateClientSettings", this.state.eventId);
  };
  clearEventData = () => {
    this.hubConnection.invoke("clearEventData", this.state.eventId);
    this.snackbarHandler("EventDataCleared", "success");
  };

  getAgenda = (eventId) => {
    Axios.get("./api/meeting/agenda/" + eventId)
      .then((res) => {
        if (!Array.isArray(res.data)) return;
        this.setState({ agenda: res.data });
      })
      .catch((err) => console.error(err));
  };
  sendResponse = (clientAnswer) => {
    this.hubConnection.invoke("moderateClientResponse", clientAnswer);
  };
  handleResponseEditing = (value, answerId) => {
    const clientResponses = Array.from(this.state.clientResponses);
    let indexOf = clientResponses.findIndex((c) => {
      return c.answerId === answerId;
    });
    if (indexOf > -1) clientResponses[indexOf].answer = value;
    this.setState({ clientResponses });
  };
  clearQuestionAnswers = (qId) => {
    this.hubConnection.invoke("clearQuestionAnswers", this.state.eventId, qId);
  };
  removeClientQuestionData = () => {
    this.hubConnection.invoke("removeClientQuestionData", this.state.eventId);
  };
  activateSpeaker = (id, speakerId, duration = null) => {
    let agendaItemId = this.state.showAgendaInfo || this.state.agenda.find((a) => a.active === true).agendaItemId;
    if (!agendaItemId || !this.state.connected) return;

    this.hubConnection.invoke("activateSpeaker", this.state.eventId, agendaItemId, id, duration, speakerId).then((_) => {
      if (this.state.speakers.find((s) => s.speakerId === speakerId)?.active == true) this.snackbarHandler("SpeakerActivated", "info");
      if (this.state.speakers.find((s) => s.speakerId === speakerId)?.active == false) this.snackbarHandler("SpeakerDeactivated", "info");
    });
  };
  renderClientView = () => {
    const { user } = this.props;
    const { clientResponses, eventId, selectedQuestion, orderList, speakers } = this.state;
    let questionName = "";
    let isActive = this.state.selectedQuestion !== null;
    if (isActive) {
      let qs = selectedQuestion.questionLanguage.find((ql) => ql.languageCode == (user.userLang || this.state.eventLang || "swe"));
      questionName = qs ? qs.label : "";
    }
    let label = "Clients";
    let speakerActions = false;
    let filteredSpeakers = speakers;
    let closeView = null;
    let parentId = null;
    let subLabel = "";
    return (
      <ClientOverview
        removeClientData={this.removeClientQuestionData}
        clear={this.clearResponsesOnPresenter}
        sendResponse={this.sendResponse}
        clientViewRef={this.clientViewRef}
        label={label}
        speakers={filteredSpeakers}
        speakerActions={speakerActions}
        clientList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_CLIENT || cl.type == clientTypeConstants.INTERACTION_MEETING)}
        subLabel={subLabel}
        allowSpeaker={this.state.allowSpeaker}
        clientResponses={clientResponses}
        allowChat={this.state.allowChat}
        setSpeaker={this.setSpeaker}
        parentId={parentId}
        selectChat={this.selectChat}
        selectedQuestion={selectedQuestion}
        activeAgenda={this.state.agenda?.find((a) => a.active === true)}
        textEditing={this.handleResponseEditing}
        chat={this.state.chats}
        activateSpeaker={this.activateSpeaker}
        questionName={questionName}
        // activeSpeaker={this.state.speakers && this.state.speakers.find((a) => a.active === true)}
        speakers={this.state.speakers}
        removeSpeaker={this.removeSpeaker}
        orderList={orderList}
        active={isActive}
        user={user}
        eventCode={this.state.eventCode || this.state.eventId}
        closeView={closeView}
        sideView={true}
        eventId={eventId}
      />
    );
  };
  setSpeaker = (agendaItemId, speakerType, clientKey, parentId = null, activate = false) => {
    const { eventId } = this.state;
    this.hubConnection
      .invoke("setSpeaker", {
        eventId,
        agendaItemId,
        clientKey,
        parentId,
        speakerType: speakerType,
        activate,
      })
      .catch((err) => {
        console.error(err);
      });
  };
  removeSpeaker = (agendaItemId, clientKey, parentId = null) => {
    const { eventId } = this.state;
    this.hubConnection
      .invoke("removeSpeaker", {
        eventId,
        agendaItemId,
        clientKey,
        parentId,
      })
      .catch((err) => {
        console.error(err);
      });
  };

  renderSideView = () => {
    const { user } = this.props;
    const { clientResponses, eventId, selectedQuestion, activeQuestions, orderList, speakers, agenda, selectedAgenda } = this.state;
    let questionName = "";
    let isActive = this.state.selectedQuestion !== null;
    if (isActive) {
      let qs = selectedQuestion.questionLanguage.find((ql) => ql.languageCode == (this.state.eventLang || user.userLang || "swe"));
      questionName = qs ? qs.label : "";
    }

    if (this.state.questionAgendaSplitView && !selectedQuestion && !selectedAgenda) {
      return (
        <Card className="dark-card" style={{ margin: "10px", marginRight: "0px", height: "calc(100% - 10px)" }}>
          <CardContent style={{ minHeight: "98%", maxHeight: "98%" }}>
            <AgendaList
              allowChat={this.state.allowChat}
              questions={this.props.questions}
              activeQuestions={activeQuestions}
              /*           activePresenterQuestion={activePresenterQuestion} */
              deployQuestionToClients={this.deployQuestionToClients}
              selectedQuestion={selectedQuestion}
              toggleQuestionInfo={this.toggleQuestionInfo}
              handlePresetOnChange={this.updateMeetingLayoutPresets}
              deletePresetItem={this.deleteMeetingLayoutPreset}
              agenda={this.state.agenda}
              eventId={this.state.eventId}
              capturePreset={this.capturePreset}
              selectPreset={this.selectPreset}
              questionTagList={this.state.questionTagList}
              selectAgenda={this.selectAgenda}
              activatePresetItem={this.activatePresetItem}
              handleAgendaOnChange={this.handleAgendaOnChange}
              deleteAgendaItem={this.deleteAgendaItem}
              deactivateSpeakers={this.deactivateAgendaSpeakersOnClose}
              activeAgenda={this.state.activeAgenda}
              selectedAgenda={this.state.selectedAgenda}
              activateAgenda={this.activateAgenda}
              selectChat={this.selectChat}
              /*    meetingList={meetingList} */
              events={this.state.breakouts}
              eventName={this.state.eventName}
              chats={this.state.chats}
              lang={this.state.eventLang || user.userLang || "swe"}
              orderList={this.state.orderList}
              currentChat={this.state.currentChat}
              allowSpeaker={this.state.allowSpeaker}
              eventId={this.state.eventId}
              speakers={this.state.speakers}
              showSpeakers={this.showSpeakers}
              connected={this.state.connected}
              restoreAgendaItem={this.restoreAgendaItem}
              updateQuestions={this.updateQuestions}
              presetItems={this.state.presetItems}
              deployQuestionToPresenter={this.deployQuestionToPresenter}
              user={user}
              hubConnection={this.hubConnection}
            />
          </CardContent>
        </Card>
      );
    }

    if (this.state.showClients === true) {
      let label = "Clients";
      let speakerActions = false;
      let filteredSpeakers = speakers;
      let closeView = null;
      let parentId = null;
      let subLabel = "";
      if (this.state.showAgendaInfo) {
        return (
          <SpeakerOverview
            hubConnection={this.hubConnection}
            removeClientData={this.removeClientQuestionData}
            clear={this.clearResponsesOnPresenter}
            sendResponse={this.sendResponse}
            label={label}
            speakers={filteredSpeakers}
            speakerActions={speakerActions}
            agendaSpeakers={this.state.agenda.find((a) => a.agendaItemId == this.state.showAgendaInfo)}
            clientList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING)}
            subLabel={subLabel}
            clientResponses={clientResponses}
            activateSpeaker={this.activateSpeaker}
            parentId={parentId}
            setSpeaker={this.setSpeaker}
            removeSpeaker={this.removeSpeaker}
            selectedQuestion={selectedQuestion}
            textEditing={this.handleResponseEditing}
            questionName={questionName}
            orderList={orderList}
            active={isActive}
            activeAgenda={agenda.find((a) => a.active === true)}
            user={user}
            deactivateSpeakers={this.deactivateAgendaSpeakersOnClose}
            closeView={closeView}
            eventId={eventId}
          />
        );
      }
    }

    if (selectedQuestion !== null) {
      return (
        <QuestionOverview
          removeClientData={this.removeClientQuestionData}
          activeQuestions={activeQuestions}
          clear={this.clearResponsesOnPresenter}
          clearQuestionAnswers={this.clearQuestionAnswers}
          sendResponse={this.sendResponse}
          clientList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_CLIENT || cl.type == clientTypeConstants.INTERACTION_MEETING)}
          clientResponses={selectedQuestion ? clientResponses.filter((cr) => cr.questionId === selectedQuestion.questionId) : []}
          questionPresentParticipants={this.state.questionPresentParticipants}
          toggleQuestionInfo={this.toggleQuestionInfo}
          refreshQuestionList={this.refreshQuestionList}
          selectedQuestion={selectedQuestion}
          textEditing={this.handleResponseEditing}
          questionName={questionName}
          lang={this.state.eventLang || user.userLang || "swe"}
          orderList={orderList}
          toggleSnackbar={this.toggleSnackbar}
          snackbarHandler={this.snackbarHandler}
          personTypes={this.state.personTypes}
          active={isActive}
          user={user}
          eventId={eventId}
        />
      );
    }
    if (selectedAgenda != null) {
      return (
        <AgendaEditView
          removeClientData={this.removeClientQuestionData}
          activeQuestions={activeQuestions}
          deleteAgendaItem={this.deleteAgendaItem}
          clear={this.clearResponsesOnPresenter}
          clearQuestionAnswers={this.clearQuestionAnswers}
          sendResponse={this.sendResponse}
          clientList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_CLIENT || cl.type == clientTypeConstants.INTERACTION_MEETING)}
          clientResponses={selectedQuestion ? clientResponses.filter((cr) => cr.questionId === selectedQuestion.questionId) : []}
          toggleQuestionInfo={this.toggleQuestionInfo}
          orderList={orderList}
          toggleSnackbar={this.toggleSnackbar}
          snackbarHandler={this.snackbarHandler}
          deselectAgendaItem={() => this.setState({ selectedAgenda: null })}
          personTypes={this.state.personTypes}
          active={isActive}
          user={user}
          restoreAgendaItem={this.restoreAgendaItem}
          agenda={this.state.agenda}
          handleAgendaOnChange={this.handleAgendaOnChange}
          selectedAgenda={this.state.selectedAgenda}
          eventId={eventId}
        />
      );
    }
    if (this.state.currentChat != null && this.state.allowChat) {
      return (
        <ChatWindow
          selectChat={this.selectChat}
          connectionList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING)}
          chats={this.state.chats}
          orderList={this.state.orderList}
          currentChat={this.state.currentChat}
          eventId={this.state.eventId}
          sendMessage={this.sendMessage}
          scroll={this.state.scroll}
        />
      );
    }
    if (this.state.selectedPreset !== null) {
      return (
        <PresetOverview
          selectedPreset={this.state.presetItems.find((p) => p.interactionPresetId == this.state.selectedPreset)}
          removeClientData={this.removeClientQuestionData}
          activeQuestions={activeQuestions}
          clear={this.clearResponsesOnPresenter}
          clearQuestionAnswers={this.clearQuestionAnswers}
          sendResponse={this.sendResponse}
          clientList={this.state.connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_CLIENT || cl.type == clientTypeConstants.INTERACTION_MEETING)}
          clientResponses={selectedQuestion ? clientResponses.filter((cr) => cr.questionId === selectedQuestion.questionId) : []}
          toggleQuestionInfo={this.toggleQuestionInfo}
          refreshQuestionList={this.refreshQuestionList}
          selectedQuestion={selectedQuestion}
          textEditing={this.handleResponseEditing}
          questionName={questionName}
          orderList={orderList}
          toggleSnackbar={this.toggleSnackbar}
          snackbarHandler={this.snackbarHandler}
          personTypes={this.state.personTypes}
          active={isActive}
          user={user}
          eventId={eventId}
        />
      );
    }
  };
  renderIncommingDataList = () => {
    // const { user } = this.props;
    const { clientResponses } = this.state;
    // let questionName = "";
    // let isActive = this.state.selectedQuestion !== null;
    // if (isActive) {
    //   questionName = this.state.selectedQuestion.questionLanguage.find(
    //     (ql) => ql.languageCode == (user.userLang || "swe")
    //   ).label;
    // }
    clientResponses.map((r) => {
      if (r.type === "Option") {
        let oId = parseInt(r.answer);
        r.answer = this.convertOptionIdToText(oId, r.questionId).toString();
      }
      return r;
    });
  };

  onReceiveMessage = (res) => {
    const chats = Array.from(this.state.chats);
    const resChat = chats.find((c) => c.target == res.sender);
    const currentChat = deepClone(this.state.currentChat);
    if (resChat) {
      let index = chats.indexOf(resChat);
      if (index > -1) {
        if (currentChat && currentChat.target == chats[index].target) {
          chats[index].seen = true;
          res.seen = true;
          this.setMessageSeen(res.target);
        }
        chats[index].messages.push(res);
        chats[index].previewText = res.message;
        chats[index].previewPrefix = res.sender == "MODERATOR" ? "You" : res.senderFirstName + " " + res.senderLastName;
        chats[index].lastChange = res.inserted;
        if (currentChat && currentChat.target != chats[index].target) {
          chats[index].seen = false;
        }
      }
    } else {
      chats.push({
        lastChange: res.inserted,
        messages: [res],
        previewText: res.message,
        previewPreFix: res.senderFirstName + " " + res.senderLastName,
        target: res.sender,
        seen: false,
      });
    }

    this.setState({ chats, /* currentChat, */ scroll: true });
    setTimeout(() => this.setState({ scroll: false }), 1000);
  };
  onSendChatMessage = (res) => {
    const chats = Array.from(this.state.chats);
    const resChat = chats.find((c) => c.target == res.receiver);
    const currentChat = deepClone(this.state.currentChat);
    if (resChat) {
      let index = chats.indexOf(resChat);
      if (index > -1) chats[index].messages.push(res);

      if (currentChat && resChat.target == currentChat.target) {
        currentChat.previewText = res.message;
        currentChat.previewPrefix = res.sender == "MODERATOR" ? "You" : res.senderFirstName + " " + res.senderLastName;
        currentChat.lastChange = res.inserted;
        currentChat.messages.push(res);
      }
      resChat.previewText = res.message;
      resChat.previewPrefix = res.sender == "MODERATOR" ? "You" : res.senderFirstName + " " + res.senderLastName;
      resChat.lastChange = res.inserted;
    } else {
      chats.push({
        lastChange: res.inserted,
        messages: [res],
        previewText: res.message,
        previewPreFix: "",
        target: res.receiver,
        seen: false,
      });
      if (currentChat && currentChat.target == res.receiver) {
        currentChat.messages.push(res);
      }
    }

    this.setState({ chats, currentChat, scroll: true });
    setTimeout(() => this.setState({ scroll: false }), 1000);
  };
  onGetChatMessages = (res) => {
    if (res) {
      this.setState({ chats: res, loaded: true });
    }
  };
  sendMessage = (text) => {
    const { currentChat } = this.state;
    const { eventId } = this.state;
    let target = currentChat.target;
    let room = `Event:${eventId}`;
    if (currentChat && currentChat.target == `ALL`) target = null;

    let isValid = text && text.length <= 500;

    if (isValid) {
      this.hubConnection.invoke("sendChatMessage", eventId, "MODERATOR", target, text, null, "", false, false);
    }
  };
  setMessageSeen = (target) => {
    const { eventId } = this.state;
    this.hubConnection.invoke("setMessageSeen", eventId, "MODERATOR", target, null);
  };
  onLike = (messageId) => {
    const currentChat = deepClone(this.state.currentChat);
    if (!currentChat) return;

    currentChat.messages.map((m) => {
      if (m.interactionChatId == messageId) {
        if (m.likes == null) m.likes = 0;
        m.likes += 1;
      }
    });
    this.setState({ currentChat });
  };
  like = (messageId) => {
    const { hubConnection, eventId } = this.props.extraProps;

    if (hubConnection) {
      hubConnection.invoke("like", messageId, eventId);
    }
  };
  selectChat = (target) => {
    const { chats, autoScrollLocked } = this.state;
    let currentChat = chats.find((c) => c.target == target);
    let missedGroupMessages = this.state.missedGroupMessages;
    if (!currentChat)
      currentChat = {
        lastChange: "",
        messages: [],
        previewText: "",
        previewPreFix: "",
        target: target,
        seen: true,
      };
    const updatedChat = chats;
    if (currentChat && !currentChat.seen) {
      let chatIndex = chats.indexOf(chats.find((c) => c.target == currentChat.target));
      if (chatIndex > -1) {
        chats[chatIndex].messages.map((m) => {
          m.seen = true;
        });
      }

      let index = updatedChat.indexOf(currentChat);
      if (index > -1) {
        updatedChat[index].seen = true;
        updatedChat[index].messages.map((m) => {
          m.seen = true;
        });
      }
      currentChat.seen = true;
      if (currentChat.target != "ALL") {
        this.setMessageSeen(currentChat.target);
      }
      if (updatedChat[index]) {
      }
    }

    if (target == "ALL") {
      missedGroupMessages = 0;
    }
    this.setState({
      currentChat,
      selectedQuestion: null,
      selectedAgenda: null,
      selectedPreset: null,
      showAgendaInfo: null,
      autoScrollLocked: false,
      hiddenMessages: 0,
      chats: updatedChat,
      missedGroupMessages,
    });
  };
  toggleAside = (open) => this.setState({ asideOpen: open });
  showClients = () => this.setState({ showClients: true });
  activateAgenda = (agenda) => this.setState({ activeAgenda: agenda });
  toggleSnackbar = (val) => this.setState({ snackbar: { message: "", show: val } });
  updateQuestions = (q) => this.snackbarHandler("QuestionListUpdated", "success");

  handleAgendaOnChange = (agenda, local = false) => {
    if (local) {
      this.setState({ agenda });
    } else {
      const requestOptions = {
        method: "PUT",
        headers: /* authHeader( */ {
          "Content-Type": "application/json",
        } /* ) */,
        body: JSON.stringify(agenda),
      };

      return fetch(`./api/meeting/agenda`, requestOptions)
        .then(handleResponse)
        .then((a) => {
          this.setState({ agenda: a });
          this.snackbarHandler("AgendaUpdated");
          this.hubConnection.invoke("updateAgenda", this.state.eventId, a).catch((err) => {
            console.error(err);
          });
        });
    }
  };
  deleteAgendaItem = (id) => {
    const requestOptions = {
      method: "DELETE",
      headers: /* authHeader( */ { "Content-Type": "application/json" } /* ) */,
    };

    return fetch(`./api/meeting/agenda/delete/${id}`, requestOptions)
      .then(handleResponse)
      .then((res) => {
        let uptAgenda = Array.from(this.state.agenda);
        uptAgenda = uptAgenda.filter((ua) => ua.agendaItemId !== res.id);
        this.setState({ agenda: uptAgenda });
        this.snackbarHandler("AgendaUpdated");
        this.hubConnection.invoke("updateAgenda", this.state.eventId, uptAgenda).catch((err) => {
          console.error(err);
        });
      });
  };
  selectAgenda = (selectedAgenda) =>
    this.setState({
      selectedAgenda,
      selectedChat: null,
      selectedQuestion: null,
      selectedPreset: null,
    });
  snackbarHandler = (message, status = "success") => {
    this.setState({ snackbar: { message, show: true, status } });
    setTimeout(() => this.setState({ snackbar: { message: "", show: false } }), 3000);
  };

  render() {
    const { questions, user, templates } = this.props;
    const { activeQuestions, activePresenterQuestion, selectedQuestion, clientTemplateId, forceQuestion, connectionList, eventId } = this.state;
    let presenterList = connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_PRESENTER);
    let clientList = connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_CLIENT);
    let moderatorList = connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MODERATOR);
    let meetingList = connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING);

    if (!this.state.init) return <Loader />;
    const connectionsProps = { hubConnection: this.hubConnection, ...this.state };
    return (
      <div
        style={{
          overflow: "hidden",
          background: "#121212",
          height: "100vh",
          width: "100%",
        }}
      >
        <HeaderBar
          eventId={eventId}
          clientTemplateId={clientTemplateId}
          updateClientSettings={this.updateClientSettings}
          forceQuestion={forceQuestion}
          templates={templates}
          activeModulesChanged={this.state.activeModulesChanged}
          asideOpen={this.state.asideOpen}
          eventCode={this.state.eventCode}
          toggleAside={this.toggleAside}
          arenaClosed={this.state.arenaClosed}
          splitView={this.state.questionAgendaSplitView}
          toggleSplitView={() => this.setState({ questionAgendaSplitView: !this.state.questionAgendaSplitView })}
          setArenaClosed={this.setArenaClosed}
          code={this.state.code}
          tickCode={this.state.tickCode}
          updateMeetingLayout={this.updateMeetingLayout}
          updateModulesList={this.updateModulesList}
          saveMeetingLayoutPreset={this.saveMeetingLayoutPreset}
          meetingLayoutPresets={this.state.presetItems}
          deleteModule={this.deleteModule}
          addModule={this.createModule}
          selectPreset={this.selectPreset}
          user={user}
          modules={this.state.modules}
          lang={this.state.eventLang || user.userLang || "swe"}
          presenterSettings={this.state.presenterSettings}
          eventName={this.state.eventName}
          clearEventData={this.clearEventData}
          setForceQuestion={this.setForceQuestion}
          parentEvent={this.state.parentEvent}
          hubConnection={this.hubConnection}
          eventCode={this.state.eventCode}
          breakouts={this.state.breakouts}
          updatePresenterSettings={this.updatePresenterSettings}
        />
        <div
          style={{
            width: "100%",
            height: "calc(100vh - 61px)",
            display: "inline-flex",
          }}
        >
          <div style={{ width: "20%", height: "100%", paddingLeft: "10px" }}>
            <ActiveInfo
              clientTemplateId={clientTemplateId}
              presenterList={presenterList}
              showSpeaker={this.showSpeaker}
              clientList={clientList}
              templates={templates}
              moderatorList={moderatorList}
              meetingList={meetingList}
              chats={this.state.chats}
              currentChat={this.state.currentChat}
              showSpeaker={this.showSpeaker}
              personTypes={this.state.personTypes}
              activeSpeaker={this.state.speakers && this.state.speakers.find((a) => a.active === true)}
              setActiveInfoRef={(r) => (this.activeInfoRef = r)}
              attendees={this.state.orderList}
              toggleClientView={this.showClients}
            />
            <div
              ref={(r) => (this.clientViewRef = r)}
              style={{
                width: "100%",
                height: `calc(100% - ${this.activeInfoRef ? this.activeInfoRef.clientHeight : 0}px)`,
              }}
            >
              {this.renderClientView()}
            </div>
          </div>
          <div style={{ width: "80%", height: "100%" }}>
            <div style={{ width: "100%", height: "100%", display: "inline-flex" }}>
              <div style={{ width: "50%", height: "100%" }}>
                <ActiveItems
                  allowChat={this.state.allowChat}
                  questions={questions}
                  activeMobileLayout={this.state.activeMobileLayout}
                  activeQuestions={activeQuestions}
                  activePresenterQuestion={activePresenterQuestion}
                  deployQuestionToClients={this.deployQuestionToClients}
                  selectedQuestion={selectedQuestion}
                  toggleQuestionInfo={this.toggleQuestionInfo}
                  handlePresetOnChange={this.updateMeetingLayoutPresets}
                  deletePresetItem={this.deleteMeetingLayoutPreset}
                  agenda={this.state.agenda}
                  eventId={this.state.eventId}
                  capturePreset={this.capturePreset}
                  selectPreset={this.selectPreset}
                  questionTagList={this.state.questionTagList}
                  selectAgenda={this.selectAgenda}
                  activatePresetItem={this.activatePresetItem}
                  handleAgendaOnChange={this.handleAgendaOnChange}
                  deleteAgendaItem={this.deleteAgendaItem}
                  deactivateSpeakers={this.deactivateAgendaSpeakersOnClose}
                  activeAgenda={this.state.activeAgenda}
                  selectedAgenda={this.state.selectedAgenda}
                  activateAgenda={this.activateAgenda}
                  selectChat={this.selectChat}
                  meetingList={meetingList}
                  events={this.state.breakouts}
                  eventName={this.state.eventName}
                  chats={this.state.chats}
                  lang={this.state.eventLang || user.userLang || "swe"}
                  orderList={this.state.orderList}
                  currentChat={this.state.currentChat}
                  allowSpeaker={this.state.allowSpeaker}
                  eventId={this.state.eventId}
                  speakers={this.state.speakers}
                  showSpeakers={this.showSpeakers}
                  connected={this.state.connected}
                  restoreAgendaItem={this.restoreAgendaItem}
                  updateQuestions={this.updateQuestions}
                  presetItems={this.state.presetItems}
                  deployQuestionToPresenter={this.deployQuestionToPresenter}
                  user={user}
                  hubConnection={this.hubConnection}
                />
              </div>
              <div style={{ width: "50%", height: "100%", zIndex: 1 }}>{this.renderSideView()}</div>
            </div>
          </div>
        </div>
        <ConnectionStatus {...connectionsProps} hubConnection={this.hubConnection} />
        <CustomSnackbar isOpen={this.state.snackbar.show} toggleSnackbar={this.toggleSnackbar} status={this.state.snackbar.status} message={this.state.snackbar.message} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
    questions: state.question.questions,
    templates: state.template ? state.template.templates : undefined,
  };
}

export default connect(mapStateToProps)(NewLayout);
